import { useSyncExternalStore } from "react";
const INITIAL = {
    active: null,
    hoverTargetId: null
};
let state = INITIAL;
const listeners = new Set();
function emit() {
    for (const listener of listeners)listener();
}
function subscribe(listener) {
    listeners.add(listener);
    return ()=>{
        listeners.delete(listener);
    };
}
function setHover(id) {
    if (state.hoverTargetId === id) return;
    state = {
        ...state,
        hoverTargetId: id
    };
    emit();
}
export function useHoverTargetId() {
    return useSyncExternalStore(subscribe, ()=>state.hoverTargetId, ()=>null);
}
export function useIsDropTarget(nodeId) {
    return useSyncExternalStore(subscribe, ()=>nodeId != null && state.hoverTargetId === nodeId, ()=>false);
}
export function resolveDropTarget(clientX, clientY, fromNodeId, fromHandleType, resolveDropId) {
    const nodeEl = document.elementFromPoint(clientX, clientY)?.closest(".react-flow__node");
    const rawId = nodeEl?.getAttribute("data-id") ?? null;
    if (!rawId || rawId === fromNodeId) return null;
    const resolved = resolveDropId ? resolveDropId(rawId, fromHandleType) : rawId;
    if (!resolved || resolved === fromNodeId) return null;
    return resolved;
}
function handlePointerMove(event) {
    if (!state.active) return;
    setHover(resolveDropTarget(event.clientX, event.clientY, state.active.nodeId, state.active.type, state.active.resolveDropId));
}
export function startConnectionTracking(type, nodeId, options = {}) {
    state = {
        active: {
            type,
            nodeId,
            resolveDropId: options.resolveDropId
        },
        hoverTargetId: null
    };
    emit();
    document.addEventListener("pointermove", handlePointerMove);
}
export function stopConnectionTracking() {
    document.removeEventListener("pointermove", handlePointerMove);
    if (state === INITIAL) return;
    state = INITIAL;
    emit();
}

//# sourceMappingURL=connectionDropStore.js.map